import { Link } from "react-router-dom";


const CashBack = () => {
  return ( 
    <section>
      <div className="container-fluid">
        <div className="row">
          

          <div className="col-lg-10 mt-3 mb-3">
            <div className="row">
              <div className="col-lg-1 text-end">
                <Link to="/">
                  <h6>
                    <i class="fa fa-home" aria-hidden="true"></i>Home
                  </h6>
                </Link>
              </div>
              /
              <div className="col-lg-5">
                <h6>Cashback Details</h6>
              </div>
            </div>

            <div className="row">
              <div className="card border-0 shadow ">
                <div className="card-header bg bg-info border-0">
                  <h4>Cashback Details</h4>
                </div>

                <div className="card-body text-center">
                  <div className="col-lg-10 ">
                    <div className="row ">

                        
                      {/* =======================basic start================= */}

                      <div className="col-lg-4 border border-0 rounded-3 mt-3">
                        <div className="card bg bg-warning">
                          <div className="card-body">
                            <h5 className="mt-2">CASHBACK</h5>
                            <h5 className="mt-2">Total Members - 10</h5>

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Click here
                            </Link>

                            <h5 className="mt-2">Amount : Rs 100</h5>

                            <label
                              for="exampleInputPassword1"
                              class="form-label"
                            >
                              Enter Amount:
                            </label>

                            <input
                              type="password"
                              class="form-control"
                              placeholder="Enter Amount"
                              id="exampleInputPassword1"
                            />

                            <Link
                              to=""
                              className="btn btn-danger btn-sm mt-2 mb-2"
                            >
                              Submit
                            </Link>
                          </div>
                        </div>
                      </div>

                      {/* =======================basic end================= */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CashBack;
